export default __webpack_public_path__ + "static/wallpaper-6-mb-059e81128132974f8bb7454cec1c3933.png";